(() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  let dialog;
  let image;
  let stage;
  let scale = 1;
  let x = 0;
  let y = 0;
  let startDistance = 0;
  let startScale = 1;
  let dragOrigin = null;
  let galleryTap = null;
  let suppressClickUntil = 0;
  const pointers = new Map();

  const labels = () => {
    const lang = document.documentElement.lang.toLowerCase();
    if (lang.startsWith('el')) return { close: 'Κλείσιμο', zoomIn: 'Μεγέθυνση', zoomOut: 'Σμίκρυνση', reset: 'Επαναφορά' };
    return { close: 'Close', zoomIn: 'Zoom in', zoomOut: 'Zoom out', reset: 'Reset zoom' };
  };

  const render = () => {
    image.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
  };

  const reset = () => {
    scale = 1;
    x = 0;
    y = 0;
    render();
  };

  const setScale = (nextScale) => {
    scale = clamp(nextScale, 1, 5);
    if (scale === 1) {
      x = 0;
      y = 0;
    }
    render();
  };

  const largestSource = (element) => {
    if (!element) return '';
    const candidates = (element.srcset || '').split(',').map((candidate) => {
      const parts = candidate.trim().split(/\s+/);
      return { url: parts[0], width: Number.parseInt(parts[1], 10) || 0 };
    }).filter((candidate) => candidate.url);
    candidates.sort((a, b) => b.width - a.width);
    return candidates[0]?.url || element.currentSrc || element.src || element.dataset.src || '';
  };

  const build = () => {
    const text = labels();
    dialog = document.createElement('dialog');
    dialog.className = 'atlantic-product-zoom';
    dialog.setAttribute('aria-label', text.zoomIn);
    dialog.innerHTML = `<div class="atlantic-product-zoom__controls"><button class="atlantic-product-zoom__button" type="button" data-atlantic-zoom-out aria-label="${text.zoomOut}">−</button><button class="atlantic-product-zoom__button" type="button" data-atlantic-zoom-reset aria-label="${text.reset}">1×</button><button class="atlantic-product-zoom__button" type="button" data-atlantic-zoom-in aria-label="${text.zoomIn}">+</button><button class="atlantic-product-zoom__button" type="button" data-atlantic-zoom-close aria-label="${text.close}">×</button></div><div class="atlantic-product-zoom__stage"><img class="atlantic-product-zoom__image" alt=""></div>`;
    document.body.append(dialog);
    image = dialog.querySelector('.atlantic-product-zoom__image');
    stage = dialog.querySelector('.atlantic-product-zoom__stage');

    dialog.querySelector('[data-atlantic-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-atlantic-zoom-in]').addEventListener('click', () => setScale(scale + 0.5));
    dialog.querySelector('[data-atlantic-zoom-out]').addEventListener('click', () => setScale(scale - 0.5));
    dialog.querySelector('[data-atlantic-zoom-reset]').addEventListener('click', reset);
    dialog.addEventListener('close', reset);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    stage.addEventListener('dblclick', () => setScale(scale === 1 ? 2.5 : 1));
    stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      setScale(scale + (event.deltaY < 0 ? 0.25 : -0.25));
    }, { passive: false });
    stage.addEventListener('pointerdown', (event) => {
      stage.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 1) dragOrigin = { pointerX: event.clientX, pointerY: event.clientY, x, y };
      if (pointers.size === 2) {
        const points = [...pointers.values()];
        startDistance = Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
        startScale = scale;
      }
    });
    stage.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 2) {
        const points = [...pointers.values()];
        const distance = Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
        setScale(startScale * distance / startDistance);
      } else if (scale > 1 && dragOrigin) {
        x = dragOrigin.x + event.clientX - dragOrigin.pointerX;
        y = dragOrigin.y + event.clientY - dragOrigin.pointerY;
        render();
      }
    });
    const release = (event) => {
      pointers.delete(event.pointerId);
      dragOrigin = null;
    };
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
  };

  const openFromTrigger = (trigger, eventTarget) => {
    if (!dialog) build();
    const clickedImage = eventTarget.closest?.('img');
    const visibleImage = clickedImage || trigger.querySelector?.('img:not([hidden])');
    const zoomLink = trigger.matches?.('.atlantic-product-zoom-trigger') ? trigger : trigger.closest?.('.atlantic-product-zoom-trigger');
    const source = zoomLink?.dataset.atlanticProductZoom || zoomLink?.querySelector('.js-zoom-image')?.dataset.src || largestSource(visibleImage);
    if (!source) return;
    image.src = source;
    image.alt = visibleImage?.alt || zoomLink?.querySelector('.product-image')?.alt || '';
    reset();
    if (!dialog.open) dialog.showModal();
  };

  const galleryTriggerFromEvent = (event) => {
    const pathTrigger = event.composedPath().find((element) => element.matches?.('.atlantic-product-zoom-trigger, media-gallery img.product-image, .media-gallery img.product-image'));
    if (pathTrigger) return pathTrigger;
    const point = event.changedTouches?.[0] || event;
    return document.elementFromPoint(point.clientX, point.clientY)?.closest('.atlantic-product-zoom-trigger, media-gallery img.product-image, .media-gallery img.product-image');
  };

  document.addEventListener('pointerdown', (event) => {
    const trigger = galleryTriggerFromEvent(event);
    galleryTap = trigger ? { trigger, x: event.clientX, y: event.clientY, pointerId: event.pointerId } : null;
  }, true);

  document.addEventListener('pointerup', (event) => {
    if (!galleryTap || galleryTap.pointerId !== event.pointerId) return;
    const distance = Math.hypot(event.clientX - galleryTap.x, event.clientY - galleryTap.y);
    const trigger = galleryTap.trigger;
    galleryTap = null;
    if (distance > 10) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressClickUntil = Date.now() + 700;
    openFromTrigger(trigger, event.target);
  }, true);

  document.addEventListener('pointercancel', () => {
    galleryTap = null;
  }, true);

  const bindGalleryTouch = () => {
    document.querySelectorAll('.atlantic-product-zoom-trigger').forEach((trigger) => {
      if (trigger.dataset.atlanticZoomBound === 'true') return;
      trigger.dataset.atlanticZoomBound = 'true';
      let touchStart = null;
      trigger.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
      }, { passive: true });
      trigger.addEventListener('touchend', (event) => {
        if (!touchStart) return;
        const touch = event.changedTouches[0];
        const distance = touch ? Math.hypot(touch.clientX - touchStart.x, touch.clientY - touchStart.y) : 0;
        touchStart = null;
        if (distance > 10) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClickUntil = Date.now() + 700;
        openFromTrigger(trigger, event.target);
      }, { passive: false });
    });
  };

  bindGalleryTouch();
  new MutationObserver(bindGalleryTouch).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const trigger = galleryTriggerFromEvent(event);
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (Date.now() < suppressClickUntil) return;
    openFromTrigger(trigger, event.target);
  }, true);
})();

